import React from "react";
import { delimited } from "../../../Utils";
import { Container } from "./styles.js";
import InlineSVG from "react-inlinesvg";
import { SudoTooltip } from "src/sudokit/components/SudoTooltip";

export default function Status({ wordCount, highlightedWordCount, editorOptions, saved }) {
  return (
    <Container>
      <div className="inner">
        {editorOptions.showWordCount && (
          <span>
            {wordCount !== null && highlightedWordCount < 1 && <>Words: {delimited(wordCount)}</>}
            {highlightedWordCount > 0 && <>Highlighted words: {delimited(highlightedWordCount)}</>}
          </span>
        )}
        <div className="save">
          {saved === "saved" && (
            <>
              <span>Saved &nbsp;</span>
              <InlineSVG
                src="/assets/check-simple.svg"
                height="20"
                width="20"
              />
            </>
          )}
          {saved === "saving" && (
            <>
              <span>Saving &nbsp;</span>
              <InlineSVG
                src="/assets/loader.svg"
                height="20"
                width="20"
              />
            </>
          )}
          {saved === "saved-locally" && (
            <SudoTooltip
              text="Connection lost. Your changes will sync automatically when we reconnect."
              position="bottom"
            >
              <span className="saved-locally">
                Saved Locally &nbsp;
                <InlineSVG
                  src="/assets/check-simple.svg"
                  height="20"
                  width="20"
                />
              </span>
            </SudoTooltip>
          )}
        </div>
      </div>
    </Container>
  );
}
